module.exports = __webpack_public_path__ + "aeab626580c6dded7b7ac8b0c0679396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/powertap.png
// module id = 1834
// module chunks = 1